import { STORE_WRAPPER_TOKEN, StoreWrapperInterface } from '@actassa/api';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class LoaderService {
    private state = new BehaviorSubject<number>(0);

    constructor(
        @Inject(STORE_WRAPPER_TOKEN) private storeWrapper: StoreWrapperInterface,
    ) { }

    public get state$(): Observable<boolean> {
        return this.state.pipe(map(Boolean));
    }

    public loadingStart(): void {
        const currentValue = this.state.getValue();

        if (currentValue === 0) {
            this.storeWrapper.loadingStart();
        }

        this.state.next(currentValue + 1);
    }

    public loadingEnd(): void {
        const currentValue = this.state.getValue();

        if (currentValue === 1) {
            this.storeWrapper.loadingEnd();
        }

        this.state.next(currentValue ? currentValue - 1 : 0);
    }
}
